import { PageNotFoundError } from "@src/pages/DashboardNotFound";

export function meta() {
  return [
    { title: "Page Not Found" },
    { name: "description", content: "The requested page could not be found." },
  ];
}

export default function DashboardNotFound() {
  return <PageNotFoundError />;
}
